import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    path: '/biblioteca/bibrelatorioestatistica',
    name: 'bibrelatorioestatistica',
    description: 'Estatística de Acervo',
    component: () => import('@/views/biblioteca/bibrelatorioestatistica/Configuracao.vue'),
    meta: {
      permissions: [eTipoPermissao.BIB_ESTATISTICANOVO_MENU_1300600799],
    },
    goesToMenu: true,
  },
];
